module.exports = __webpack_public_path__ + "static/media/eye.6619f061.svg";